import type { FC, MouseEvent } from 'react'

import { Flex } from '@/components/priority/Flex/Flex'
import type { QuickActionItem } from '@/types/itemControls'
import { zLayers } from '@/utils/styling/zLayers'

import { ActionItem, ActionLabel } from './ImageQuickActions.styled'

type ImageQuickActionsProps = {
  isOpen: boolean
  onClose: () => void
  actions: QuickActionItem[]
  position?: {
    top?: number
    left?: number
    right?: number
    bottom?: number
  }
}

export const ImageQuickActions: FC<ImageQuickActionsProps> = ({
  isOpen,
  onClose,
  actions,
  position = { top: 40, left: 0 },
}) => {
  if (!isOpen) {
    return null
  }

  const handleActionClick = async (action: QuickActionItem) => {
    if (action.disabled) {
      return
    }

    await action.onAction()
    onClose()
  }

  const handleOverlayClick = (event: MouseEvent) => {
    event.stopPropagation()
    onClose()
  }

  return (
    <>
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        zindex={String(zLayers.quickActions - 1)}
        background="transparent"
        onClick={handleOverlayClick}
      />
      <Flex
        position="absolute"
        zindex={String(zLayers.quickActions)}
        backgroundColor="lockedWhite"
        radius="8px"
        shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
        minWidth="180px"
        overflow="hidden"
        column
        style={position}
      >
        <Flex column padding="4px 0">
          {actions.map((action) => (
            <ActionItem
              key={action.id}
              onClick={() => handleActionClick(action)}
              $disabled={action.disabled}
              data-testid={`quick-action-${action.id}`}
            >
              <ActionLabel>{action.label}</ActionLabel>
            </ActionItem>
          ))}
        </Flex>
      </Flex>
    </>
  )
}
